<div class="col d-flex align-items-start">
    <div class="me-3">
        <i class="fa-solid fa-check activity-icon text-success"></i>
    </div>
    <div>
        <p>{{ activityText }}</p>
    </div>
</div>
